import { Box, Button, Dialog, DialogTitle, FormControl, MenuItem, Select, TextField, Tooltip, Typography } from '@mui/material'
import React, { createContext, useContext, useEffect, useRef, useState } from 'react'
import QuickScreenPairingStepperControl, { PairingScreenDataContext } from './QuickScreenPairingStepperControl'
import { useTranslation } from 'react-i18next'
import SelectFilesModalScreen from './SelectFilesModalScreen'
import SelectPlaylistModal from 'src/components/selectfilesmodal/SelectPlaylistModal'
import { FaTwitch } from 'react-icons/fa'
import { resolveSrc } from 'src/api/endpoints'
import photoPlch from '../../../images/photo-placeholder.png'
import playlistPch from '../../../images/playlist-placeholder.png'
import schedulerPch from '../../../images/scheduler-placeholder.png'
import EditIcon from '@mui/icons-material/Edit';
import { analyzeLocation } from 'src/utils/analyze-location'
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import InfoIcon from '@mui/icons-material/Info';
import SelectSchedulerModal from 'src/components/selectfilesmodal/SelectSchedulerModal'

const QuickScreenPairingDialog = ({open, onClose, socketRef}) => {
    const { t } = useTranslation()

    const [openSelectFilesModal, setOpenSelectFilesModal] = useState(false)
    const [openPlaylistModal, setOpenPlaylistModal] = useState(false)
    const [openSelectSchedulerModal, setOpenSelectSchedulerModal] = useState(false)

    const [selectedFile, setSelectedFile] = useState({type: '', name: '', id: '', data: null})
    const [isStepperOpen, setIsStepperOpen] = useState(true)

    useEffect(() => {
        if(open) {
           setIsStepperOpen(true) 
        }
    }, [open])

    const StepOne = ({}) => {
        const pairingData = useContext(PairingScreenDataContext)
        return (
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                pt: 4
            }}>
                <TextField
                    autoComplete='off'
                    variant={"outlined"}
                    size='small'
                    defaultValue={pairingData?.code}
                    fullWidth
                    id="codeInput"
                    sx={{
                        maxWidth: '300px'
                    }}
                    label={t("views.redesignScreens.pairingCodeRequired")}
                    inputProps={{ maxLength: 4, pattern: "^[0-9]{4}$" }}
                    required
                />
            </Box>
        )
    }

    const generateRandomScreenName = () => {
        const letters = 'abcdefghijklmnopqrstuvwxyz';
        let result = '';
        for (let i = 0; i < 5; i++) {
            const randomIndex = Math.floor(Math.random() * letters.length);
            result += letters[randomIndex];
        }
        return `Screen-${result}`;
    }

    const StepTwo = ({}) => {
        const [charsCount, setCharsCount] = useState(12)
        const pairingData = useContext(PairingScreenDataContext)
        return (
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                pt: 4
            }}>
                <TextField
                    autoComplete='off'
                    variant={"outlined"}
                    size='small'
                    defaultValue={pairingData.name || generateRandomScreenName()}
                    fullWidth
                    sx={{
                        maxWidth: '300px'
                    }}
                    onInput={(e) => setCharsCount(e.target.value.length)}
                    label={t("views.redesignScreens.deviceNameRequired")}
                    inputProps={{ maxLength: 20 }}
                    required
                    helperText={charsCount+" / 20"}
                />
            </Box>
        )
    }


    const GetFilePreview = ({type, contentObject}) => {
        console.log(type, contentObject)
          return type === "split_screen" ? (
                <img src={contentObject.widget?.widgetIcon} style={{ width: "150px", height: "100px", display: 'flex', justifyContent: 'center', objectFit: "contain" }} />
          ) : contentObject?.widget?.widgetCat === "website" || contentObject?.widget?.widgetCat === "postermywall" ? (
                <img src={contentObject.widget?.widgetIcon} style={{ width: "150px", height: "100px", display: 'flex', justifyContent: 'center', objectFit: "contain" }} />
          ) : contentObject?.widget?.widgetCat === "yt_playlist" ? (
              <img src={"/images/yt_app.png"} style={{ width: "150px", height: "100px", display: 'flex', justifyContent: 'center', objectFit: "contain" }} />
          ) : contentObject?.widget?.widgetCat === "twitch" ? (
            // /twitchtv?chat=true&channel=lablabai
              <FaTwitch size={"32px"} style={{ marginTop: "10px", color: "#9147ff" }} />
          ) : (
            <>
              {type === "image" && <img src={resolveSrc(contentObject.url)} style={{ height: "100px", width: "150px", objectFit: "cover", borderRadius: '8px' }} />}
              {type === "video" && <video src={resolveSrc(contentObject.url)} style={{ height: "100px", width: "150px", objectFit: "cover", borderRadius: '8px' }}></video>}
              {contentObject.embed === "embed" && <embed src={contentObject.url} style={{ height: "100px", width: "150px", objectFit: "cover", borderRadius: '8px' }}></embed>}
              {type === "widget" && <img src={contentObject.widget?.widgetIcon} style={{ width: "150px", height: "100px", display: 'flex', justifyContent: 'center', objectFit: "contain" }} />}
            </>
          )
    }

    const StepThree = ({setOpenSelectFilesModal, selectedFile, setOpenPlaylistModal}) => {
        const [cType, setCtype] = useState('def')

        useEffect(() => {
            if(cType == 'object') {
                setOpenSelectFilesModal(true)
            }else if(cType == 'playlist') {
                setOpenPlaylistModal(true)
            }else if(cType == 'scheduler') {
                setOpenSelectSchedulerModal(true)
            }
        }, [cType])

        return (
            <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "20px",
                mt: 4,
                mb: 2,
                flexWrap: "wrap"
            }}>
                <input type="text" tabIndex={-1} hidden style={{display: "none"}} id='stepData' data-assetid={selectedFile.id} data-assetname={selectedFile.name} data-assettype={selectedFile.type} />
                {selectedFile.data?.type ? (
                    <GetFilePreview type={selectedFile.data?.type} contentObject={selectedFile.data} />
                ) : (
                    <>
                        {selectedFile?.type == 'playlist' ? (
                            <img src={playlistPch} style={{height: "100px", width: "150px", objectFit: "cover", borderRadius: '8px'}} />
                        ) : selectedFile?.type == 'scheduler' ? (
                            <img src={schedulerPch} style={{height: "100px", width: "150px", objectFit: "cover", borderRadius: '8px'}} />
                        ) : (
                            <img src={photoPlch} style={{height: "100px", width: "150px", objectFit: "cover", borderRadius: '8px'}} />
                        )}
                    </>
                )}
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "10px"
                }}>
                    {selectedFile?.name && (
                        <Typography variant='subtitle1' mt={3}>{selectedFile?.name.length > 30 ? `${selectedFile?.name.slice(0, 30)}...` : selectedFile?.name}</Typography> 
                    )}
                    {!selectedFile?.name ? (
                            <>
                                <FormControl sx={{ minWidth: 150 }} size='small'>
                                    <Select value={cType} onChange={(e) => setCtype(e.target.value)}>
                                        <MenuItem value="def"><em>{t("views.scheduler.contentType")}</em></MenuItem>
                                        <MenuItem value={'object'}>{t("views.scheduler.object")}</MenuItem>
                                        <MenuItem value={'playlist'}>{t("views.scheduler.playlist")}</MenuItem>
                                        {/* <MenuItem value={'scheduler'}>{t("layout.sidebar.scheduler")}</MenuItem> */}
                                    </Select>
                                </FormControl>
                                {cType !== 'def' && (
                                    <Button variant="outlined" size='small' onClick={() => {
                                        if(cType == 'object') {
                                            setOpenSelectFilesModal(true)
                                        }else if(cType == 'playlist') {
                                            setOpenPlaylistModal(true)
                                        }else if(cType == 'scheduler') {
                                            setOpenSelectSchedulerModal(true)
                                        }
                                    }}>
                                        {t("views.redesignScreens.selectFile")}
                                    </Button>
                                )}
                            </>
                    ) : (
                        <Button variant='outlined' size="small" endIcon={<EditIcon />} onClick={() => setSelectedFile({type: '', name: '', id: '', data: null})}>
                            {t("views.redesignScreens.chooseAnotherContent")}
                        </Button>
                    )}
                </Box>
            </Box>
        )
    }

    const StepFour = () => {
        const pairingData = useContext(PairingScreenDataContext)
        const [locationDetails, setLocationDetails] = useState(null)
        const locationRef = useRef(null);
        const [location, setLocation] = useState("");
        const [lat, setLat] = useState("");
        const [lng, setLng] = useState("");
        const onGetLatLonByLocatioChange = () => {
            const placeObject = locationRef.current.getPlace();
            console.log(placeObject)
            const lat = placeObject.geometry.location.lat();
            const lng = placeObject.geometry.location.lng();
            setLocation(placeObject?.name);
            setLocationDetails(analyzeLocation(t, placeObject))
            setLat(lat);
            setLng(lng);
        };
        return (
            <> 
                <input type='text' hidden style={{display: "none"}} data-location={location} data-isfull={`${locationDetails?.fullLocation}`}
                    data-mostdetailedlevel={locationDetails?.mostDetailedLevel} data-lat={locationDetails?.lat} data-lng={locationDetails?.lng}
                    data-formattedaddress={locationDetails?.formatted_address} data-shortaddress={locationDetails?.short_address}
                />
                <Box sx={{margin: "10px auto", display: 'flex', flexDirection: 'column', maxWidth: '615px'}}>
                <Box sx={{ zIndex: "1000000000000000", display: 'flex', flexDirection: 'column', width: '100%', marginTop: '20px' }}>
                    <Typography variant="caption" color="warning.main">
                    {!locationDetails?.fullLocation ? (
                        t("views.redesignScreens.enterLocation")
                    ) : null}
                    </Typography>
                    <Box sx={{display: 'flex', width: '100%', alignItems: 'center'}}>
                    <Box sx={{width: '100%', marginTop: '10px'}}>
                        <Autocomplete onLoad={(autocomplete) => (locationRef.current = autocomplete)} onPlaceChanged={onGetLatLonByLocatioChange}>
                        <TextField
                            defaultValue={pairingData?.location}
                            type={"text"}
                            label={t("views.redesignScreens.location")}
                            variant={"standard"}
                            value={location}
                            onChange={(e) => setLocation(e.target.value)}
                            fullWidth
                            required
                        />
                        </Autocomplete>
                    </Box>
                    {!locationDetails?.fullLocation ? (
                        <Tooltip title={t("views.redesignScreens.enterLocationTip")} placement="left">
                        <InfoIcon sx={{color:'#FFA726'}}/>
                        </Tooltip>
                    ) : null}
                    </Box>
                </Box>
                {locationDetails ? (
                    <Typography variant="caption" color={locationDetails.labelColor}>{locationDetails.labelMsg}</Typography>
                ) : null}
                </Box>
            </>
        )
    }

    const resetFormAndClose = () => {
        setSelectedFile({type: '', name: '', id: '', data: null})
        setIsStepperOpen(false)
        onClose()
    }

    const syncScreen = (mac) => {
        socketRef?.current?.emit("sync", { detail: { mac: mac } })
    }

    return (
        <>
            <SelectFilesModalScreen
                open={openSelectFilesModal}
                setOpenSelectFiles={setOpenSelectFilesModal}
                onSaveFiles={() => {}}
                onSaveFilesForQuickP={(selectedFiles) => {
                    if (selectedFiles) {
                        console.log(selectedFiles)
                        // const selected = content.find((asset) => asset.id === selectedFiles[0]);
                        setSelectedFile({type: 'object', name: selectedFiles.name, id: selectedFiles.id, data: selectedFiles});
                        setOpenSelectFilesModal(false);
                    }
                }}
            />
            <SelectPlaylistModal open={openPlaylistModal} onClose={() => setOpenPlaylistModal(false)} onSelectPlaylist={(p) => {
                setSelectedFile({type: 'playlist', name: p.playlistName, id: p._id});
            }} />
            <SelectSchedulerModal open={openSelectSchedulerModal} onClose={() => setOpenSelectSchedulerModal(false)} onSelectScheduler={sch => {
                setSelectedFile({type: 'scheduler', name: sch.name, id: sch._id});
            }} />
            <Dialog open={open} onClose={resetFormAndClose} fullWidth maxWidth="md" sx={{
                p:3
            }}> 
                <DialogTitle textAlign="center">Quickly pair your screen</DialogTitle>
                {isStepperOpen && (
                    <QuickScreenPairingStepperControl syncScreen={syncScreen} resetFormAndClose={resetFormAndClose} step1={<StepOne />} step2={<StepTwo />} step3={<StepThree setOpenPlaylistModal={setOpenPlaylistModal} selectedFile={selectedFile} setOpenSelectFilesModal={setOpenSelectFilesModal} />} step4={<StepFour />} />
                )}
            </Dialog>
        </>
    )
}

export default QuickScreenPairingDialog
